export function logEvent(_name: string, _props?: Record<string, unknown>): void {
  // noop stub for analytics/telemetry
}

